import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { ClienteCadastroSituacaoChartComponent, ClienteCadastroSituacaoCardChartComponent } from './cadastro-situacao';
import { ClienteSegmentoChartComponent, ClienteSegmentoCardChartComponent } from './segmento';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClienteCadastroSituacaoChartComponent,
        ClienteCadastroSituacaoCardChartComponent,
        ClienteSegmentoChartComponent,
        ClienteSegmentoCardChartComponent
    ],
    exports: [
        ClienteCadastroSituacaoChartComponent,
        ClienteSegmentoChartComponent
    ]
})
export class ClienteCadastroSituacaoChartModule { }
